<app-provider-form-wrapper
  data-testid="e-invoice-provider-form-wrapper"
  #formWrapper
  [config]="config()"
  [editMode]="editMode()"
  [viewMode]="viewMode()"
></app-provider-form-wrapper>
